import { render, staticRenderFns } from "./InformationNavigation.vue?vue&type=template&id=6d0d270f&scoped=true"
import script from "./InformationNavigation.vue?vue&type=script&lang=ts"
export * from "./InformationNavigation.vue?vue&type=script&lang=ts"
import style0 from "./InformationNavigation.vue?vue&type=style&index=0&id=6d0d270f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d270f",
  null
  
)

export default component.exports